import React from "react";
import SvgIcon from "@mui/material/SvgIcon";
export const Space = props => {
    return (React.createElement(SvgIcon, Object.assign({}, props),
        React.createElement("polygon", { points: "4.02767932 9.93848047 6.02524862 9.93848047 6.02524862 14 18.004291 14 18.004291 10.1240241 20.0274174 10.1240241 20.0274174 16 4.02767932 16" })));
};
export default Space;
